const state = {
  height: 0,
  difference: 0,
}

const actions = {
  /**
   * @desc Store the actual heights of the Navbar and promoBar rather
   *     than using by a static min-height/padding-top SCSS variable.
   *     Store the Navbar's height as the difference, since it's height
   *     is the difference between the normal document flow and the visual
   *     flow.
   */
  setHeight: ({ commit }, { navbar, promoBar }) => {
    commit('SET_HEIGHT', navbar + promoBar);
    commit('SET_DIFFERENCE', navbar);
  }
}

const mutations = {
  SET_HEIGHT: (state, value) => {
    state.height = value;
  },
  SET_DIFFERENCE: (state, value) => {
    state.difference = value;
  }
}

export default { namespaced: true, state, mutations, actions }
